module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-28.13a3c9d4.jpg";